import React, { Component } from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import getConfig from 'next/config';
const { serverRuntimeConfig, publicRuntimeConfig } = getConfig();
export default class index extends Component {
    render() {
        return (
            <div className="how-does-it-works pt-sm-5 pb-sm-5">
                <div className="pt-2 pb-2">
                <h2 className="text-center work-title">How does it work?</h2>
                <Container>
                    <div className="pt-sm-4 pb-sm-4">
                        <Row>
                            <Col className="work-bg-img" md>
                                <div className="text-center pt-sm-3">
                                    <img src={`${publicRuntimeConfig.staticFolder}/images/select-issue.svg`} alt="Select your device" className="" />
                                    <div className="work-sec-item">
                                        Select your <br />device & issue
                                </div>
                                </div>
                            </Col>
                            <Col className="work-bg-img2" md>
                                <div className="text-center pt-3">
                                    <img src={`${publicRuntimeConfig.staticFolder}/images/Chat.svg`} alt="Get free quote" className="" />
                                    <div className="work-sec-item">
                                        Get a FREE <br />quote instantly
                                </div>
                                </div>
                            </Col>
                            <Col className="work-bg-img3">
                                <div className="text-center pt-3">
                                    <img src={`${publicRuntimeConfig.staticFolder}/images/Technician.svg`} alt="Doorstep Repair Service" className="" />
                                    <div className="work-sec-item">
                                        Technician visits you <br />to fix device in no time
                                </div>
                                </div>
                            </Col>
                        </Row>
                    </div>
                </Container>
                </div>
                <style jsx global>
                    {`
                    .work-bg-img {
                        background-image: url('/static/images/one.png');
                        background-position: left;
                        background-repeat: no-repeat;
                        background-size: auto; 
                        background-position-x: 85px;
                        background-position-y: 46px;
                    }
                    .work-bg-img2 {
                        background-image: url('/static/images/two.png');
                        background-position: left;
                        background-repeat: no-repeat;
                        background-size: auto; 
                        background-position-x: 85px;
                        background-position-y: 46px;
                    }
                    .work-bg-img3 {
                        background-image: url('/static/images/three.png');
                        background-position: left;
                        background-repeat: no-repeat;
                        background-size: auto; 
                        background-position-x: 40px;
                        background-position-y: 46px;
                    }
                    `}
                </style>
            </div>
        )
    }
}
